import { requireAuth } from '@/features/auth/guards/require-auth'
import { GoodsReceiptEditorPage } from '@/features/goods-receipts/pages/goods-receipt-editor-page'
import { goodsReceiptDetailQuery } from '@/features/goods-receipts/queries/goods-receipt-queries'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/goods-receipts/$goodsReceiptId')({
  beforeLoad: async (params) => {
    const ctx = await requireAuth(params)
    if (!ctx.user.is_staff) {
      throw redirect({ to: '/projects/' })
    }
    return ctx
  },
  loader: ({ context: { queryClient }, params }) => {
    const goodsReceiptId = Number(params.goodsReceiptId)
    return Promise.all([
      queryClient.ensureQueryData(goodsReceiptDetailQuery(goodsReceiptId)),
      queryClient.ensureQueryData(projectsListQuery()),
      queryClient.ensureQueryData(usersListQuery()),
    ]).then(([receipt]) => ({ number: receipt.number }))
  },
  component: GoodsReceiptDetailRoute,
  // Crumb: «<список> › <номер документа>» — the number from the loader, not the id.
  staticData: {
    crumbParent: { label: messages.crumbs.goodsReceipts, to: '/goods-receipts/' },
    crumb: (m: { loaderData?: { number: string } }) => m.loaderData?.number ?? '…',
  },
})

function GoodsReceiptDetailRoute() {
  const { goodsReceiptId } = Route.useParams()
  return <GoodsReceiptEditorPage goodsReceiptId={Number(goodsReceiptId)} />
}
